
export default {
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnim()
    })
  },
  methods: {
    initAnim() {
      // const { container } = this.$refs
      const gsap = this.$gsap

      const TL1 = gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          markers: false,
          start: 'top bottom',
          end: '20% 20%',
          trigger: '#sections-performance',
          endTrigger: '#performance-goals',
        },
      })
      const TL2 = gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          markers: false,
          start: 'top',
          end: 'top',
          trigger: '#second-anchor',
        },
      })
      const TL3 = gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          markers: false,
          start: 'top',
          end: 'top',
          trigger: '#third-anchor',
        },
      })
      const TL4 = gsap.timeline({
        scrollTrigger: {
          scrub: 0.5,
          markers: false,
          start: 'top',
          end: 'top',
          trigger: '#fourth-anchor',
        },
      })
      TL1.from('#goals', { alpha: 0, duration: 0.5 })
      TL2.from('#track', { alpha: 0, duration: 1 })
      TL3.from('#drive', { alpha: 0, duration: 0.5 })
      TL4.from('#celebrate', { alpha: 0, duration: 0.5 })
    },
  },
}
